<template>
  <div
    id="vue-site-wide-alerts"
  >
    <Alerts :alerts="alerts" />
  </div>
</template>

<script>
import Alerts from "./components/Alerts.vue";
import axios from "axios";

export default {
  name: "App",
  components: {
    Alerts,
  },
  data() {
    return {
      alerts: [],
      env: process.env.NODE_ENV,
      endpoint: process.env.VUE_APP_API_URL,
    };
  },
  computed: {
    currentRouteName() {
      return this.isTranslated(window.location.pathname);
    },
    language() {
      let lang = this.isTranslated(window.location.pathname);
      if (lang =='/ar') {
        return 'ar';
      } else if (lang =='/es') {
        return 'es';
      } else if (lang =='/zh') {
        return 'zh';
      }
      return 'en';
    },

    langEndpoint() {
      let language = this.isTranslated(window.location.pathname);
      const environment = this.env === 'production' ? 'prod' : 'staging';
      if (language) {
        return `https://translated-endpoints-json.s3.amazonaws.com/${environment}/${language}/site_wide_alerts.json`;
      }
      return this.endpoint;
    },
  },
  created () {
    let vm = this;
    vm.init();
  },
  methods: {
    async init () {
      await this.getAlerts();
    },
    async getAlerts() {
      await axios
        .get( this.langEndpoint)
        .then(response => {
          this.alerts = response.data;
        })
        .catch(e => {}); // eslint-disable-line no-unused-vars
    },
    isTranslated(path) {
      let urlSegments = path.split("/");
      const supportedLanguages = [ 'ar', 'es', 'zh', 'fr', 'ht', 'pt', 'ru', 'vi', 'sw' ];
      return urlSegments.find(segment => supportedLanguages.includes(segment)) || null;
    },
    translateLink(link) {
      let self = this;
      return self.currentRouteName ? self.currentRouteName+link : link;
    },
  },
};
</script>
